import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useLocalizedRouter } from '@src/hooks/useLocalizedRouter';
import { getDefaultLocale, getLocaleForCountryCodeLang, getUnlocalizedPath } from '@src/i18n/locale.util';
import { COOKIES } from '@src/utils/constants.util';
import { setBrowserCookie } from '@src/utils/cookies.util';
const setCookie = async () => {
  // set a session cookie
  setBrowserCookie(COOKIES.geoRedirectionModal, 'true', 'path=/');
};
const getRedirectUrl = (selectedCountryCode: string) => {
  const url = new URL(window.location.href);
  const unlocalizedPath = getUnlocalizedPath(url.pathname);
  const userLang = window.navigator.language ?? getDefaultLocale().lang;
  const selectedLocale = getLocaleForCountryCodeLang(selectedCountryCode?.toLowerCase(), userLang);
  const redirectPathname = `${selectedLocale?.path}${unlocalizedPath}`;
  url.pathname = redirectPathname;
  return url.toString();
};
export const useGeoRedirectionModalHandlers = t0 => {
  const $ = _c(10);
  const {
    selectedCountryCode,
    onClose
  } = t0;
  const router = useLocalizedRouter();
  const [isLoading, setIsLoading] = useState(false);
  let t1;
  if ($[0] !== onClose || $[1] !== router || $[2] !== selectedCountryCode) {
    t1 = () => {
      setCookie();
      if (!selectedCountryCode) {
        onClose();
        return;
      }
      const redirectUrl = getRedirectUrl(selectedCountryCode);
      if (!redirectUrl) {
        onClose();
        return;
      }
      setIsLoading(true);
      router.push(redirectUrl, {
        hard: true
      });
    };
    $[0] = onClose;
    $[1] = router;
    $[2] = selectedCountryCode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onConfirm = t1;
  let t2;
  if ($[4] !== onClose) {
    t2 = () => {
      onClose();
      setCookie();
    };
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onCancel = t2;
  let t3;
  if ($[6] !== isLoading || $[7] !== onCancel || $[8] !== onConfirm) {
    t3 = {
      onConfirm,
      onCancel,
      isLoading
    };
    $[6] = isLoading;
    $[7] = onCancel;
    $[8] = onConfirm;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};